import fitCurve from 'fit-curve'

const addCurve = (acc, [p1, p2, p3, p4]) =>
    // prettier-ignore
    `${acc} ${acc === '' ? `M ${p1[0]} ${p1[1]}` : ''} C ${p2[0]} ${p2[1]}, ${ p3[0] } ${p3[1]}, ${p4[0]} ${p4[1]} `

export default (points) =>
    fitCurve(points.concat(points.slice(0, 20))).reduce(addCurve, '')
